/* Tooltip */

  let fsr_skyvault_tooltip_trigger = Array.from(document.querySelectorAll('.fsr-skyvault-tooltip-trigger'))
  fsr_skyvault_tooltip_trigger.forEach(trigger => {
    let wrapper = trigger.parentElement.querySelector('.fsr-skyvault-tooltip-wrapper')
    trigger.addEventListener('click', () => {
      wrapper.classList.remove('fsr-skyvault-tooltip-wrapper-hide')
      document.body.style.overflow = 'hidden'
    })
  })

  let fsr_skyvault_tooltip_wrapper_inner_closes = Array.from(document.querySelectorAll('.fsr-skyvault-tooltip-wrapper-inner-close'))
  fsr_skyvault_tooltip_wrapper_inner_closes.forEach(close => {
    let wrapper = close.parentElement.parentElement
    close.addEventListener('click', () => {
      wrapper.classList.add('fsr-skyvault-tooltip-wrapper-hide')
      document.body.style.overflow = 'unset'
    })
  })

  let fsr_skyvault_tooltip_wrappers = Array.from(document.querySelectorAll('.fsr-skyvault-tooltip-wrapper'))
  fsr_skyvault_tooltip_wrappers.forEach(wrapper => {
    wrapper.addEventListener('click', (event) => {
      if (event.target == wrapper){
        wrapper.classList.add('fsr-skyvault-tooltip-wrapper-hide')
        document.body.style.overflow = 'unset'
      }
    })
  })